






































































import { Component, Vue } from "vue-property-decorator";
import Layout from "@/components/Layout.vue"; // @ is an alias to /src
import MainSlogan from "@/components/common/MainSlogan.vue"; // @ is an alias to /src
import WordOnPic from "@/components/common/WordOnPic.vue";
import PicWall from "@/components/common/PicWall.vue";

@Component({
  components: {
    Layout,
    MainSlogan,
    WordOnPic,
    PicWall,
  },
})
export default class ChargePile extends Vue {
  sfour: string = require("@/assets/storage/img/sfour.png");
  format(p: number) {
    return p / 10 + "x小时";
  }
}
